import _ from 'underscore'

const INITIAL_STATE = {
  list: {},
  Selected: {},
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'SelectedItem':
      return {
        ...state,
        Selected: {
          ...state.Selected,
          [payload.item.categoryCode]: {
            ...state[payload.item.categoryCode],
            checked: payload.checked || false,
            categoryCode: payload.item.categoryCode,
            categoryDescription: payload.item.categoryDescription,
            cpdCourse: payload.item.cpdCourse,
          },
        },
      }
    case 'RemoveSelected':
      return {
        ...state,
        Selected: _.omit(state.Selected, payload.categoryCode),
      }
    case 'RemoveAllSelected':
      return {
        ...state,
        Selected: {},
      }

    case 'RowsTable':
      return {
        ...state,
        list: payload,
      }

    default:
  }
  return { ...state }
}
